import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент для визуального разделения контента.
 *
 * [Ссылка на макет](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD/%F0%9F%8C%90-Web-Components?node-id=52918-10306&p=f&t=e7llDJvL18iLAOe2-0)
 */
export const Divider = _ref => {
  let {
    direction = 'horizontal',
    colorType = 'default',
    dashPattern = 'solid'
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    role: "separator",
    className: clsx(styles['divider'], styles[direction], styles["dashPattern_".concat(dashPattern)], styles[colorType])
  });
};